export async function retry(_ref, action) {
  let times = _ref.times,
    delay = _ref.delay,
    refresh = _ref.refresh,
    backoff = _ref.backoff,
    cancelRetryIf = _ref.cancelRetryIf;
  const _cancelRetryIf = cancelRetryIf ?? (_ => false);
  const _backoff = backoff ?? 2;
  for (;;) {
    try {
      return await action();
    } catch (e) {
      if (--times < 0 || _cancelRetryIf(e)) {
        throw e;
      }
      const currentTimeout = delay;
      await (refresh == null ? void 0 : refresh());
      await new Promise(resolve => setTimeout(resolve, currentTimeout));
      delay *= _backoff;
    }
  }
}
//# sourceMappingURL=retry.js.map